import styled from 'styled-components'

export const Container = styled.main`
  width: unset !important;
  height: calc(100% - 64px) !important;
  overflow-y: scroll;
  margin: 32px 56px;
  padding-right: 164px;
  display: flex;
  flex-direction: column;
  gap: 48px;

  section {
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #C8C8C8;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;

    header {
      padding-bottom: 26px;
      border-bottom: 2px solid #EFEFEF;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 18px;

      h4 {
        color: #353744;
        font-weight: 900;
        font-size: 24px;
        line-height: 34px;
      }

      h6 {
        color: #3D6666;
        font-weight: 800;
        font-size: 12px;
        line-height: 18px;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }

    article {
      display: flex;
      flex-direction: column;

      strong {
        color: #353744;
        font-weight: 900;
        font-size: 14px;
        line-height: 21px;
      }

      span {
        color: #65666A;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: baseline;
        gap: 4px;
        
        h6 {
          font-weight: 800;
          font-size: 14px;
          line-height: 21px;
          color: #65666A;
          margin-top: 8px;
        }
      }

      strong + span {
        margin-top: 8px;
      }
    }

    article + article {
      margin-top: 32px;
    }
  }

  span.icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
`

export const SectionArticlesTitle = styled.h5`
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  color: #7B7C82;
  margin: 30px 0 24px;
`

export const ArticleTable = styled.table`
  width: fit-content;
  margin-top: -12px;
  margin-left: -18px;
  border-collapse: separate;
  border-spacing: 18px 16px;
  color: #65666A;

  td:first-of-type {
    font-weight: 900;
    color: #353744;
    width: fit-content;
  }
`

export const AreaOfPracticeContainer = styled.div`
  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #353744;
  }
`

export const SubCategoriesContainer = styled.div`
  padding: 10px;
`
export const PatentSection = styled.div`
  display: flex;
  flex-direction: column;
`